import { api } from '../../lib/api.ts';

export interface RecordingRow {
  id: string;
  status: string;
  durationSec: number | null;
  sizeBytes: number | null;
  createdAt: string;
}

export async function startRecording(meetingId: string, captureMime: string): Promise<{ id: string }> {
  const r = await api.post<{ id: string }>(`/meetings/${meetingId}/recording/start`, { captureMime });
  return r.data;
}

export async function uploadChunk(id: string, seq: number, blob: Blob): Promise<void> {
  await api.post(`/recordings/${id}/chunk`, blob, {
    params: { seq },
    headers: { 'Content-Type': 'application/octet-stream' },
  });
}

export async function finalizeRecording(id: string): Promise<void> {
  await api.post(`/recordings/${id}/finalize`);
}

export async function deleteRecording(id: string): Promise<void> {
  await api.delete(`/recordings/${id}`);
}

export async function listRecordings(meetingId: string): Promise<RecordingRow[]> {
  const r = await api.get<RecordingRow[]>(`/meetings/${meetingId}/recordings`);
  return r.data;
}

// Builds the full URL to GET the recording's Range-streamed audio. Plain
// string builder (matches meetingsApi.attachmentUrl / documentUrl) — the
// browser/player supplies the auth cookie; use api's blob-fetch pattern
// instead if a bearer-only session ever needs authed playback.
export function audioUrl(id: string): string {
  return `/api/recordings/${id}/audio`;
}

// Fetches a signed play-URL for the recording. The returned URL contains a
// JWT token (?t=...) that the browser's <audio> element can use without
// sending the bearer token.
export async function getPlayUrl(id: string): Promise<string> {
  const r = await api.get<{ url: string }>(`/recordings/${id}/play-url`);
  return r.data.url;
}
